export default {
    common: {
        email: 'Email',
        LoginBtn: 'Login',
        SignUpBtn: 'Sign up',
        SubmitBtn: 'Submit',
        ExitBtn: 'Exit',
        LogoutBtn: 'Logout'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Please check your email for the verification code.',
        VerificationCode: 'Verification code'
    },
    header: {
        OrderHistory: 'Order history',
        MYACCOUNT: 'MY ACCOUNT',
        WelcomeBack: 'Welcome back'
    },
    detail: {
        TotalOrders: 'Total Orders',
        TotalProducts: 'Total Products',
        WonderlandPoints: 'Wonderland Points',
        APMCredits: 'APM Credits',
        ExpireOn: 'Expire on',
        NoAPMCredits: 'No APM credits',
        CreditsLoading: 'Credits loading'
    },
    panel: {},
    entry: {
        Client: 'Customer',
        OrderDate: 'Order Date',
        DeliverDate: 'Delivery Date',
        Description: 'Description',
        Total: 'Total'
    },
    board: {
        Order: 'ORDER',
        Date: 'DATE',
        Total: 'TOTAL'
    },
    order: {
        OrderID: 'Order ID',
        PurchasePlace: 'Location',
        PurchaseDate: 'Purchase date',
        TotalPrice: 'Total Price',
    },
    product: {
        Name: 'Name',
        SKU: 'SKU',
        Size: 'Size',
        Quantity: 'Quantity',
        Price: 'Price',
        WarrantyUntil: 'Warranty Until',
    }
}


// WEBPACK FOOTER //
// ./src/locales/en/index.js